import { render, staticRenderFns } from "./ProcessFrequencyModal.vue?vue&type=template&id=4ec91a99&scoped=true&"
import script from "./ProcessFrequencyModal.vue?vue&type=script&lang=js&"
export * from "./ProcessFrequencyModal.vue?vue&type=script&lang=js&"
import style0 from "./ProcessFrequencyModal.vue?vue&type=style&index=0&id=4ec91a99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec91a99",
  null
  
)

export default component.exports